import Class from './variable-pie';
import './variable-pie@';
import './variable-pie.scss';

export default Class;